import { Table, TableBody, TableHead } from "@mui/material";
import React from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { SkuFormData } from "@/components/screens/ProductFormPage/types";
import { IKitComponentInput } from "@/interfaces/kit.interface";
import { KitTableMessages } from "@/messages/products/kit-table.messages";

import { KitTableRow } from "./row";
import { KITS_TABLE_COLUMNS } from "../../constants";

interface Props {
  sku: SkuFormData;
  messages: KitTableMessages;
  onEdit: (kit: IKitComponentInput) => void;
  onRemove: (kit: IKitComponentInput) => void;
}

export function KitTable({ sku, messages, onEdit, onRemove }: Props) {
  const columns = KITS_TABLE_COLUMNS(messages);

  const showKitTable = !!sku?.kitComponents;

  return (
    <TableContainer>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableHeaderRow>
            {columns.map((label, index) => (
              <HeaderTableCell key={`${index} - ${label}`}>{label}</HeaderTableCell>
            ))}
          </TableHeaderRow>
        </TableHead>
        <TableBody>
          {showKitTable &&
            sku.kitComponents.map((singleKit, index) => {
              return (
                <KitTableRow
                  key={`${index} - ${singleKit.id}`}
                  kit={singleKit}
                  index={index}
                  messages={messages}
                  onEdit={onEdit}
                  onRemove={onRemove}
                />
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
